import { render, staticRenderFns } from "./CreditLimit.vue?vue&type=template&id=624ec9a4&"
import script from "./CreditLimit.vue?vue&type=script&lang=js&"
export * from "./CreditLimit.vue?vue&type=script&lang=js&"
import style0 from "./CreditLimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports